








































import Vue, { PropOptions } from 'vue';
import { PropType } from 'vue';
import {ISelectOption as iso} from '@/class/models/typed/wild';
export type IOption = iso;
import * as models from '@/class/models/views/graph';

export default Vue.extend({
  name: 'ListChart',
  props: {
    parentData: Object,
    materials: {
      type: Array as PropType<models.IDomain[]>, // propsの型を指定
    },
  },
  data() {
    return {
      items: [] as any[],
      fields: [] as any[],
    };
  },
  mounted() {
    this.setList();
  },
  watch: {
    parentData: {
      deep: true,
      async handler(newValue, oldInput) {
        this.setList();
      },
    },
  },
  methods: {
    setSplit(text: string) {
      return text.split(/ /);
    },
    setSplitBR(text: string) {
      return text.split('<br>');
    },
    isDisp(text: string) {
      if (text.includes('一般') || text.includes('特別')) {
        return true;
      } else {
        return false;
      }
    },
    isNull(text: string) {
      if (text.includes('null')) {
        return true;
      } else {
        return false;
      }
    },
    is36violation() {
      if (this.materials) {
        if (this.materials[1].key) { // 存在チェック
          if (this.materials[1].key === '36協定違反') {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    },
    isBannedAppList() {
      if (this.materials) {
        if (this.materials[1].key) { // 存在チェック
          if (this.materials[1].key === '禁止アプリ利用者リスト') {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    },
    setList() {
      if (this.parentData.datasets) {
        let name = '　';

        if (this.materials) {
          if (this.materials[1].key) { // 存在チェック
            // console.log(this.materials[1].key);
            switch (this.materials[1].key) {
              case '36協定状況':
                name = '36協定';
                break;
              case '36協定違反':
              case '禁止アプリ利用者リスト':
                name = '氏名';
                break;
            }
          }
        }

        this.fields = this.parentData.datasets.map((v: any, i: number) => ({
          key: i.toString(), label: v.label, formatter: v.formatter, sortable: true,
        }));
        this.fields.unshift({key: 'name', sortable: false, label: name});
        // console.log(this.parentData.labels)
        this.items = this.parentData.labels.map((v: any, i: number) => {
          const returnValue = {} as any;
          returnValue.name = v;
          for (const index of Object.keys(this.parentData.datasets)) {
            returnValue[index] = this.parentData.datasets[index].data[i];
          }
          return returnValue;
        });
      }

      if (this.materials) {
        switch (this.materials[1].key) { // 部署 氏名の表示順入れ替え
          case '36協定違反':
          case '禁止アプリ利用者リスト':
            if (this.fields[0] && this.fields[0].key === 'name') {
              this.fields.splice(0, 2, this.fields[1], this.fields[0]);
            }
            break;
        }
      }
    },
  },
});
